var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inline-flex items-center"},[_vm._t("primary-button"),_vm._v(" "),_c('z-divider',{class:['flex-shrink-0', _vm.dividerHeight],attrs:{"color":_vm.dividerColor,"direction":"vertical","margin":"mx-0"}}),_vm._v(" "),_vm._t("menu")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }